module.exports = __webpack_public_path__ + "img/1125891202.0acb5b6c.jpg";